import { h, Fragment } from "preact";
import ProductOptionPill from "./product-option-pill";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";

export default function ProductOptionPills({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
}) {
  return (
    <div className="product-options__pills">
      <div className="product-options__name">{optionName}</div>
      <div className="product-options__selected-value product-options__selected-value--pills">
        {sanitizeOptionValue(selectedOptionValue)}
      </div>
      <div className="product-options__pill-list">
        {optionValues.map((optionValue) => (
          <ProductOptionPill
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
          />
        ))}
      </div>
    </div>
  );
}
